import Swal from "sweetalert2";
import api from "../../../utilidades/interceptor";
const urlApi = process.env.REACT_APP_API_KEY

export const getOperadoresVetados = (setDataTable,id_user) => {
    api.get(`${urlApi}/talentoHumano/operadoresVetados?id_user=${id_user}`).then((res) => {
        setDataTable(res.data)
    })
        .catch((error) => {
            console.log("error", error);
        })
}
export const getPermissions = (setPermission,id_user) => {
    api.get(`${urlApi}/talentoHumano/getPermissionEditOp?id_user=${id_user}`).then((res) => {
        setPermission(res.data)
    })
        .catch((error) => {
            console.log("error", error);
        })
}
export const getClientes = (setState) => {
    api.get(`${urlApi}/talentoHumano/getClientes`).then((res) => {
        setState(res.data)
    })
        .catch((error) => {
            console.log("error", error);
        })
}
export const getOperadores = (setState) => {
    api.get(`${urlApi}/talentoHumano/getOperador`).then((res) => {
        setState(res.data)
    })
        .catch((error) => {
            console.log("error", error);
        })
}
export const vetarOreactivarOp = (status, id) => {
    const params = {
        status: status,
        id: id
    }
    api.patch(`${urlApi}/talentoHumano/vetarOreactivarOp`, params).then((res) => {

    })
        .catch((error) => {
            console.log("error", error);
        })
}
export const vetarOperador = (setDataTable, id_chofer, id_cliente, fecha, observaciones, id_user) => {
    const request = {
        id_chofer,
        id_cliente,
        fecha,
        observaciones,
        id_user
    }
    api.post(`${urlApi}/talentoHumano/addOperadorVetado`, request).then((res) => {
        getOperadoresVetados(setDataTable)
        Swal.fire({
            icon: "success",
            title: "Operador vetado correctamente",
            showConfirmButton: false,
            timer: 1500
        });
    })
        .catch((error) => {

            Swal.fire({
                icon: "error",
                title: error,
                showConfirmButton: false,
                timer: 1500
            });
        })
}